import {ModuleEnum} from "../../config/constant";
import {removeHTML} from "jzfz-web-utils";

/**
 * 数据转换
 * @param data
 * @param exclude  要排除的转换的字段
 */
export const dataTranslate = (data: any, exclude: string[] = []): any => {
    const { learnMaterialConnects, standardMissionConnects, labelInfos, questionConnects } = data;
    let params = {
        learnMaterialConnects: (learnMaterialConnects || []).map((v: any) => {return {learnMaterialPkid: v.pkid}}), // 学习资料
        standardMissionConnects: (standardMissionConnects || []).map(v => { return {standardMissionPkId: v.pkid} }),    // 标准任务
        labelInfos: (labelInfos || []).map((v: any) => v.labelId),  // 标签管理
        questionConnects: (questionConnects || []).map((v: any) => ({questionId: v.pkid})),
    }
    exclude.forEach((v: string) => {
        delete params[v];
    })

    return params;
}


// 各个模块表单字段
export const moduleNameAndPkid = [
    {name: 'articleConnects', pkid: 'articlePkid', title: '国家规范', type: ModuleEnum.standard},
    {name: 'regulationConnects', pkid: 'regulationPkid', title: '规定问题', type: ModuleEnum.rules},
    {name: 'typicalConnects', pkid: 'typicalProblemPkid', title: '典型问题', type: ModuleEnum.typical},
    {name: 'learnMaterialConnects', pkid: 'pkid', title: '学习资料', type: ModuleEnum.learn},
    {name: 'standardMissionConnects', pkid: 'pkid', title: '标准任务', type: ModuleEnum.standardTask},
    {name: 'standardMapConnects', pkid: 'pkid', title: '标准图集', type: ModuleEnum.standardMap},
    {name: 'questionConnects', pkid: 'pkid', title: '自测题目', type: ModuleEnum.exam},
];


// 查询所有直接关联的知识的pkid集合
export const getDirectConnectPkids = (data: any): string[] => {
    let pkIds = moduleNameAndPkid.reduce((prev: any, next: any) => {
        return [...prev, ...(data[next.name] || []).map((item: any) => item[next.pkid])];
    }, [])
    return pkIds;
}


// 查询各个类型知识的主键字段名
export const getPkidName = (moduleType: ModuleEnum): string => {
    let fieldName = 'pkid';    // 当前文章主键
    if (moduleType === ModuleEnum.rules) {
        fieldName = 'regulationPkid';
    }
    if (moduleType === ModuleEnum.learn) {
        fieldName = 'materialId';
    }
    if (moduleType === ModuleEnum.standardTask) {
        fieldName = 'taskId';
    }
    if (moduleType === ModuleEnum.standardMap) {
        fieldName = 'mapPagePkId';
    }
    return fieldName;
}


export const getTitle = (moduleType: ModuleEnum, data: any): string => {
    // 国家规范
    if (moduleType === ModuleEnum.standard) {
        const { standardName, standardCode, articleCode } = data;
        return `${standardName} ${standardCode || ''}  |  ${articleCode}`;
    }
    // 典型问题
    if (moduleType === ModuleEnum.typical) {
        const { typicalProblemPkid } = data;
        return `ID: ${typicalProblemPkid}`;
    }
    // 规定问题
    if (moduleType === ModuleEnum.rules) {
        const {regulationPath, regulationSimpleContent} = data;
        return `${regulationPath} | ${regulationSimpleContent}`;
    }
    // 标准任务
    if (moduleType === ModuleEnum.standardTask) {
        const { name } = data;
        return name;
    }
    // 学习资料
    if (moduleType === ModuleEnum.learn) {
        const { name } = data;
        return name;
    }
    // 相关题目
    if (moduleType === ModuleEnum.exam) {
        const { content } = data;
        return removeHTML(content);
    }
    // 标准图集
    if (moduleType === ModuleEnum.standardMap) {
        const {mapCode, mapName, fullNamePath, mapPage, figureNumber} = data;
        return `${mapCode}${mapName}  ${fullNamePath}  ${mapPage}${figureNumber ? '  |  ' + figureNumber : ''}`
    }

}


const connectUtil = {
    dataTranslate,
    getDirectConnectPkids,
    getPkidName,
    moduleNameAndPkid,
    getTitle,
}


export default connectUtil;
